import { WooCommerceRestaurantHoursValue } from '../../core/interfaces/woo-commerce/api/restaurant/restaurant-api.interface';

export interface WorkingHoursRange {
  startTime: string;
  closeTime: string;
  range: string;
}

export function getWorkingHoursForDate(
  date: Date,
  workingHours: WooCommerceRestaurantHoursValue[]
): WorkingHoursRange | null {
  // Use the selected calendar date directly to avoid timezone day-shift
  const weekdayMap = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ];
  const weekday = weekdayMap[date.getDay()];
  const dayHours = workingHours.find(
    (h) => h.weekday.toLowerCase() === weekday.toLowerCase()
  );

  if (dayHours?.is_opened && dayHours.start_time && dayHours.close_time) {
    const startTime = dayHours.start_time.toUpperCase();
    const closeTime = dayHours.close_time.toUpperCase();
    return {
      startTime,
      closeTime,
      range: `${startTime} - ${closeTime}`
    };
  }

  return null;
}

export interface FormattedHours {
  weekdays: string;
  startWorkAt?: string;
  endWorkAt?: string;
  isOpen: boolean;
}

export function formatBusinessHours(
  hours: WooCommerceRestaurantHoursValue[]
): FormattedHours[] {
  const groupedHours: { [timeRange: string]: string[] } = {};
  let closedDays: string[] = [];

  for (const day of hours) {
    // const shortDay: string = getShortDay(day.weekday);

    if (!day.is_opened) {
      closedDays.push(day.weekday);
      continue;
    }

    const formattedTime = `${day.start_time?.toUpperCase()} - ${day.close_time?.toUpperCase()}`;

    if (!groupedHours[formattedTime]) {
      groupedHours[formattedTime] = [];
    }

    groupedHours[formattedTime].push(day.weekday);
  }

  let result: FormattedHours[] = [];

  // Add open hours
  for (const [timeRange, days] of Object.entries(groupedHours)) {
    const [startWorkAt, endWorkAt] = timeRange.split(' - ');
    result.push({
      weekdays: formatDayRange(days),
      startWorkAt,
      endWorkAt,
      isOpen: true
    });
  }

  // Add closed days
  if (closedDays.length > 0) {
    result.push({
      weekdays: formatDayRange(closedDays),
      isOpen: false
    });
  }

  return result;
}

function getShortDay(weekday: string): string {
  const abbreviations: { [key: string]: string } = {
    Monday: 'M',
    Tuesday: 'T',
    Wednesday: 'W',
    Thursday: 'Th',
    Friday: 'F',
    Saturday: 'S',
    Sunday: 'S'
  };

  return abbreviations[weekday] || weekday;
}

function formatDayRange(days: string[]): string {
  if (days.length > 1) {
    return `${days[0]}-${days[days.length - 1]}`;
  }

  return days[0];
}
